import type { InstallmentStatus } from "@/types/installment";

export type InstallmentCountKey =
  | "all"
  | "scheduled"
  | "presented"
  | "collected"
  | "settled"
  | "failed"
  | "offline"
  | "skipped";

export interface TabDef {
  key: string;
  label: string;
  statuses: InstallmentStatus[] | null;
  /** Value sent to the API's `status` filter. */
  apiStatus?: string;
  /** Key of the counts object returned by the API. */
  countKey: InstallmentCountKey;
}

export const TAB_DEFS: TabDef[] = [
  { key: "All", label: "All", statuses: null, countKey: "all" },
  { key: "Scheduled", label: "Scheduled", statuses: ["SCHEDULED"], apiStatus: "SCHEDULED", countKey: "scheduled" },
  { key: "Presented", label: "Presented", statuses: ["PRESENTED"], apiStatus: "PRESENTED", countKey: "presented" },
  {
    key: "Collected",
    label: "Collected",
    statuses: ["COLLECTED", "SETTLEMENT_PENDING", "SETTLED"],
    apiStatus: "COLLECTED",
    countKey: "collected",
  },
  { key: "Settled", label: "Settled", statuses: ["SETTLED"], apiStatus: "SETTLED", countKey: "settled" },
  {
    key: "Failed",
    label: "Failed",
    statuses: ["FAILED", "SETTLEMENT_FAILED"],
    apiStatus: "FAILED",
    countKey: "failed",
  },
  {
    key: "Collected Offline",
    label: "Collected Offline",
    statuses: ["COLLECTED_OFFLINE"],
    apiStatus: "OFFLINE",
    countKey: "offline",
  },
  { key: "Skipped", label: "Skipped", statuses: ["SKIPPED"], apiStatus: "SKIPPED", countKey: "skipped" },
];

interface Props {
  counts: Record<string, number>;
  active: string;
  onChange: (key: string) => void;
}

export default function StatusTabs({ counts, active, onChange }: Props) {
  return (
    <div className="overflow-x-auto rounded-[10px] border border-line bg-card p-1 shadow-card">
      <div className="flex min-w-max gap-1">
        {TAB_DEFS.map((tab) => {
          const selected = active === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => onChange(tab.key)}
              className={`inline-flex items-center gap-2 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                selected ? "bg-primary-500 text-white" : "text-ink-secondary hover:bg-page hover:text-ink"
              }`}
            >
              {tab.label}
              <span
                className={`inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[11px] font-semibold ${
                  selected ? "bg-white/20 text-white" : "bg-badgeSlate-bg text-slate-600"
                }`}
              >
                {counts[tab.key] ?? 0}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}